import { Component, Input, OnInit, AfterViewInit, ViewChild, ViewChildren, QueryList, ElementRef, TemplateRef } from '@angular/core';

const PAGE_HEIGHT = 1123; // px, A4 at 96dpi

@Component({
  selector: 'app-template2',
  templateUrl: './template2.component.html',
  styleUrls: ['./template2.component.scss']
})
export class Template2Component implements OnInit {
  @Input() data: any;
  @Input() isThumbnail: boolean = false;

  measureContainer!: ElementRef;
  sectionRefs!: QueryList<ElementRef>;

  constructor() {}

  ngOnInit(): void {
    // if (this.data && Array.isArray(this.data.experience)) {
    //   this.data.experience.forEach(exp => {
    //     exp.descriptionPoints = exp.description
    //       ? exp.description.split(/\.(?!\d)/)
    //           .map(point => point.trim())
    //           .filter(point => point.length > 0)
    //       : [];
    //   });
    // }
  }
}
